const langsShim = {
  /**
   * Mirrors the old langs.where() method.
   * @param {string} type - Formerly '1' for ISO-639-1. Now ignored, as Intl handles everything.
   * @param {string} code - The language code (e.g., 'de', 'en', 'fr')
   */
  where(type, code) {
    // Safety net in case no code is passed
    if (!code || typeof code !== 'string') {
      return { local: code || '-' };
    }

    try {
      const cleanCode = code.trim();

      // Use the native browser API
      const displayNames = new Intl.DisplayNames([cleanCode], { type: 'language' });
      let localName = displayNames.of(cleanCode);

      if (localName) {
        // Capitalize the first letter (for browser consistency)
        localName = localName.charAt(0).toUpperCase() + localName.slice(1);
        return { local: localName };
      }
    } catch (error) {
      console.warn(`[langsShim] Error resolving code "${code}":`, error);
    }

    // Ultimate fallback in case Intl fails
    return { local: code };
  }
};

export default langsShim;
